export default __webpack_public_path__ + "static/media/B120.6d5eb9ca.png";